import React from 'react';
import { styled } from '@mui/material/styles';

/** Immagini generiche nel markdown (non anteprima Meta). */
export const ChatMarkdownPlainImg = styled('img')(({ theme }) => ({
  display: 'block',
  width: '100%',
  maxWidth: 220,
  height: 'auto',
  maxHeight: 240,
  marginTop: theme.spacing(1.25),
  marginBottom: theme.spacing(1.25),
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[2],
  objectFit: 'cover',
}));

/** Anteprima Meta fuori dalle tabelle: thumbnail compatto (no Card: in tabella rompeva layout e celle). */
const ChatMarkdownMetaThumb = styled('img')(({ theme }) => ({
  display: 'block',
  width: 120,
  height: 120,
  maxWidth: '100%',
  objectFit: 'cover',
  objectPosition: 'center top',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[1],
  margin: `${theme.spacing(1)} 0`,
}));

function isMetaCreativePreviewSrc(
  src: string | undefined,
  alt: string | undefined,
): boolean {
  if (!src) return false;
  if (/fbcdn\.net|facebook\.com|fb\.com/i.test(src)) return true;
  if (alt && /^Ad:\s*/i.test(alt.trim())) return true;
  return false;
}

/**
 * Renderer per `react-markdown` / remark-gfm: anteprime creative Meta come thumbnail.
 * Nelle tabelle GFM lo stile `table img` in styled.ts forza 56×56; senza Card evita celle “vuote” giganti.
 */
export function ChatMarkdownImg(
  props: React.ImgHTMLAttributes<HTMLImageElement> & { node?: unknown },
) {
  const {
    node: _n,
    children: _c,
    src,
    alt,
    className,
    width,
    height,
    ...rest
  } = props;
  const safeSrc = src ?? '';

  if (!isMetaCreativePreviewSrc(safeSrc, alt)) {
    return (
      <ChatMarkdownPlainImg
        src={safeSrc}
        alt={alt ?? ''}
        loading="lazy"
        className={className}
        width={width}
        height={height}
      />
    );
  }

  const title = (alt ?? '').replace(/^Ad:\s*/i, '').trim() || 'Creative';

  return (
    <ChatMarkdownMetaThumb
      {...rest}
      src={safeSrc}
      alt={title}
      loading="lazy"
      decoding="async"
      className={[className, 'kipify-chat-creative-thumb']
        .filter(Boolean)
        .join(' ')}
    />
  );
}
